//
import AbsenceRequestRoutes from './HrAbsenceRequest'
import AssetDiscountRoutes from './HrAssetDiscount'
import HrContractStructure from './HrContractStructure'
import FiniquitosRoutes from './HrFiniquito'
import CompensationFundRoutes from './HrCompensationFund'
import ContractsRoutes from './HrContract'
import EmployeesRoutes from './HrEmployee'
//import EmployeeLoanCcafRoutes from './HrEmployeeLoanCcaf'
import EmployeeLoanCompanyRoutes from './HrEmployeeLoanCompany'
import FamilyAssignmentRoutes from './HrFamilyAssignment'
import HolidayRoutes from './HrHoliday'
import IsapreTypeRoutes from './HrIsapreType'
import MutualRoutes from './HrMutual'
import PayrollRoutes from './HrPayroll'
import PrevisionRoutes from './HrPrevision'
import PrevisionIndicatorsRoutes from './HrPrevisionIndicator'
import SalarySettlementsRoutes from './HrSalarySettlement'

//
export default [
    AbsenceRequestRoutes,
    AssetDiscountRoutes,
    CompensationFundRoutes,
    ContractsRoutes,
    EmployeesRoutes,
    //EmployeeLoanCcafRoutes,
    EmployeeLoanCompanyRoutes,
    FamilyAssignmentRoutes,
    FiniquitosRoutes,
    HolidayRoutes,
    HrContractStructure,
    IsapreTypeRoutes,
    MutualRoutes,
    PayrollRoutes,
    PrevisionIndicatorsRoutes,
    PrevisionRoutes,
    SalarySettlementsRoutes,
]